// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sample-requirements-dialog .type-label{color:#333;font-size:14px;line-height:18px;margin-right:23px}.sample-requirements-dialog .el-dialog{border-radius:12px}.sample-requirements-dialog .el-dialog__header{border-bottom:1px solid #e7e7e7}", ""]);
// Exports
module.exports = exports;
